import BaseAPI from './base'
/**
 * API xử lý tổng quan
 */
class EventCalendarAPI extends BaseAPI {}

export default new EventCalendarAPI('v1/event-calendar', 'EventCalendar')
